var map = {
	"./cloud-networking-table-en.svg": "stYD",
	"./cloud-networking-table-m-en.svg": "SI0Y",
	"./cloud-networking-table-m-zh.svg": "t6WY",
	"./cloud-networking-table-zh.svg": "KMtE"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "9nG4";